<template>
	<div class="color-repeater">
		<div  class="color-repeater-item" v-for="(item, index) in colorsArray" :key="index">
			<color-picker-multi :locale="locale" :input_name="'colors[' + index + '][color]'" :color="item.color"></color-picker-multi>
		</div>
		<div class="add-color-picker-button has-text-centered">
			<span class="button is-primary pr40 pl40 is-rounded pt20 pb20" @click.prevent="addToLoop({color:defaultColor})">{{ t('add_color') }}</span>
		</div>
	</div>
</template>
<script>
	import ColorPickerMulti from './ColorPickerMulti';
    import trans from '../../SiteComponents/translation/categories';
	export default {
		name:"repeater-color",
		components:{
			'color-picker-multi': ColorPickerMulti,
		},
		props:{
			colors:{
				type:Array,
			},
			defaultColor:{
				default:'#888'
			},
            locale : String

		},
        locales: trans,
		data () {
			return {
				colorsArray: this.colors
			}
		},
		methods: {
			addToLoop: function (color) {
				if(this.colorsArray != null){
					this.colorsArray.push(color);
				}
				else{
					this.colorsArray= [{"color":this.defaultColor}];
				}
			}
		},
        mounted() {
            this.$translate.setLang(this.locale);
        },
	}
</script>
<style>
.color-repeater > div{
	display: inline-block;
}
.add-color-picker-button {
	display: block!important;
}
.ColorPicker-container{
	display: inline-block;
	margin: 15px;
}
.ColorPicker-container .open-DColorPicker{
	display: inline-block;
	vertical-align: middle;
}
.ColorPicker-container .button.is-danger{
	vertical-align: middle;
}
</style>
